import React from "react";
import { getPasswordRuleChecks } from "../utils/validation";

type Props = { password: string };

/**
 * Live password requirements (aligned with toc-user-backend ValidationUtils.validatePassword).
 */
export default function PasswordRuleHints({ password }: Props) {
  const { rules, strengthPercent } = getPasswordRuleChecks(password);
  const fillClass =
    strengthPercent === 100 ? "strong" : strengthPercent >= 50 ? "medium" : "weak";

  return (
    <div className="password-rule-hints" aria-live="polite">
      <div className="password-strength-row">
        <span className="password-strength-label">Password strength: {strengthPercent}%</span>
      </div>
      <div className="password-strength-bar" role="progressbar" aria-valuenow={strengthPercent} aria-valuemin={0} aria-valuemax={100}>
        <div
          className={`password-strength-bar-fill ${fillClass}`}
          style={{ width: `${strengthPercent}%` }}
        />
      </div>
      <ul className="password-rule-list">
        {rules.map((rule) => (
          <li key={rule.id} className={rule.met ? "password-rule-row met" : "password-rule-row unmet"}>
            <span className="password-rule-icon" aria-hidden>
              {rule.met ? "✓" : "○"}
            </span>
            {rule.label}
          </li>
        ))}
      </ul>
    </div>
  );
}